import { readCookie, writeCookie } from "~/utils/cookieValue";
import {
  readSessionValue,
  writeSessionValue,
} from "~/utils/sessionStorageValue";

const SUBSCRIBED_COOKIE = "ph_updates_subscribed";
const SUBSCRIBED_TTL_DAYS = 365;
const SEEN_COOKIE = "ph_updates_seen";
const SEEN_TTL_DAYS = 180;
const BAND_DISMISSED_COOKIE = "ph_updates_band_dismissed";
const BAND_DISMISSED_TTL_DAYS = 30;

const AUTO_ASK_SESSION_KEY = "ph_updates_auto_ask";
const BAND_SHOWN_SESSION_KEY = "ph_updates_band_shown";
const NEWSLETTER_VISIT_SESSION_KEY = "ph_updates_newsletter_visit";
const PAGE_VIEWS_SESSION_KEY = "ph_updates_page_views";

export const isSubscribed = (): boolean =>
  readCookie(SUBSCRIBED_COOKIE) === "1";

export const markSubscribed = (): void =>
  writeCookie(SUBSCRIBED_COOKIE, "1", SUBSCRIBED_TTL_DAYS);

export const hasSeenUpdatesDialog = (): boolean =>
  readCookie(SEEN_COOKIE) === "1";

export const markUpdatesSeen = (): void =>
  writeCookie(SEEN_COOKIE, "1", SEEN_TTL_DAYS);

export const isBandDismissed = (): boolean =>
  readCookie(BAND_DISMISSED_COOKIE) === "1";

export const markBandDismissed = (): void =>
  writeCookie(BAND_DISMISSED_COOKIE, "1", BAND_DISMISSED_TTL_DAYS);

export const wasAutoAskUsedThisSession = (): boolean =>
  readSessionValue(AUTO_ASK_SESSION_KEY) === "1";

export const markAutoAskUsed = (): void =>
  writeSessionValue(AUTO_ASK_SESSION_KEY, "1");

export const wasBandShownThisSession = (): boolean =>
  readSessionValue(BAND_SHOWN_SESSION_KEY) === "1";

export const markBandShown = (): void =>
  writeSessionValue(BAND_SHOWN_SESSION_KEY, "1");

export const isNewsletterVisit = (): boolean =>
  readSessionValue(NEWSLETTER_VISIT_SESSION_KEY) === "1";

export const markNewsletterVisit = (): void =>
  writeSessionValue(NEWSLETTER_VISIT_SESSION_KEY, "1");

export const readPageViews = (): number => {
  const raw = readSessionValue(PAGE_VIEWS_SESSION_KEY);
  const parsed = raw === null ? 0 : Number(raw);

  return Number.isFinite(parsed) ? parsed : 0;
};

export const incrementPageViews = (): number => {
  const next = readPageViews() + 1;
  writeSessionValue(PAGE_VIEWS_SESSION_KEY, String(next));

  return next;
};
